import React from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import color from "@constants/color";
import Text from "@components/CustomText";
import { TouchableOpacity } from "react-native-gesture-handler";

const TagList = ({ tags, selectedRouteId, onPress = () => {} }) => {
  return (
    <View style={styles.container}>
      <ScrollView horizontal={true} showsHorizontalScrollIndicator={false}>
        {tags?.map((item) => (
          <TouchableOpacity
            activeOpacity={0.5}
            onPress={() => onPress(item.route_id)}
            testID="ofd-tag-list"
            style={[
              styles.tagContainer,
              {
                backgroundColor:
                  item.route_id === selectedRouteId ? color.black : color.white,
              },
            ]}
            key={item.route_name}
          >
            <Text
              variant="body_text_4"
              style={[
                styles.tagText,
                {
                  color:
                    item.route_id === selectedRouteId
                      ? color.white
                      : color.black,
                },
              ]}
            >
              {item.route_name}
            </Text>
            <Text
              variant="title_16"
              style={[
                styles.tagText,
                styles.countText,
                {
                  color:
                    item.route_id === selectedRouteId
                      ? color.white
                      : color.black,
                },
              ]}
            >
              {item.count}
            </Text>
          </TouchableOpacity>
        ))}
      </ScrollView>
    </View>
  );
};

export default TagList;

const styles = StyleSheet.create({
  container: {
    backgroundColor: color.white,
    padding: 16,
    paddingVertical: 0,
    flexDirection: "column",
    width: "100%",
  },
  tagContainer: {
    margin: 8,
    padding: 8,
    marginTop: 0,
    paddingHorizontal: 12,
    borderRadius: 8,
    marginLeft: 0,
    marginRight: 16,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    borderColor: color.lighterBlack,
    borderWidth: 1,
  },
  tagText: {
    color: color.black,
  },
  countText: {
    marginLeft: 12,
  },
});
